import { render, staticRenderFns } from "./my-settings.vue?vue&type=template&id=6fe70cd4&"
import script from "./my-settings.vue?vue&type=script&lang=js&"
export * from "./my-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports